"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSettableDictateAbortable;

var _useWebChatUIContext2 = _interopRequireDefault(require("./useWebChatUIContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function useSettableDictateAbortable() {
  var _useWebChatUIContext = (0, _useWebChatUIContext2.default)(),
      dictateAbortable = _useWebChatUIContext.dictateAbortable,
      setDictateAbortable = _useWebChatUIContext.setDictateAbortable;

  return [dictateAbortable, setDictateAbortable];
}